import { useEffect, useState } from 'react'
import confetti from 'canvas-confetti'
import AnimationLayout from './components/AnimationLayout'

interface Badge {
  name: string
  emoji: string
  description: string
  points_awarded: number
}

interface Props {
  animation: { id: number; name: string; description: string }
  badge: Badge
  all_animations: { id: number; name: string }[]
}

export default function Animation14({ animation, badge, all_animations }: Props) {
  const [showUnlock, setShowUnlock] = useState(false)
  const [showBadge, setShowBadge] = useState(false)

  useEffect(() => {
    setTimeout(() => setShowUnlock(true), 300)

    setTimeout(() => {
      setShowBadge(true)
      confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 },
        colors: ['#0F352D', '#1d5c4d', '#FFF198', '#feee80', '#fcf5cc']
      })
    }, 1500)
  }, [])

  return (
    <AnimationLayout animation={animation} allAnimations={all_animations}>
      <style>{`
        @keyframes unlock {
          0% { transform: scale(0.8); opacity: 0; }
          50% { transform: scale(1.1); }
          100% { transform: scale(1); opacity: 1; }
        }
        @keyframes slideUpFade {
          0% { transform: translateY(0); opacity: 1; }
          100% { transform: translateY(-50px); opacity: 0; }
        }
        @keyframes slideDownIn {
          0% { transform: translateY(-50px) scale(0.5); opacity: 0; }
          50% { transform: translateY(10px) scale(1.1); }
          100% { transform: translateY(0) scale(1); opacity: 1; }
        }
        @keyframes textGlow {
          0%, 100% {
            text-shadow: 0 0 20px rgba(255, 241, 152, 0.5), 0 0 40px rgba(255, 241, 152, 0.3);
          }
          50% {
            text-shadow: 0 0 40px rgba(255, 241, 152, 0.8), 0 0 80px rgba(255, 241, 152, 0.5);
          }
        }
        .unlock {
          animation: unlock 0.5s ease-out forwards;
        }
        .slide-up-fade {
          animation: slideUpFade 0.5s ease-out forwards;
        }
        .slide-down-in {
          animation: slideDownIn 0.8s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
        }
        .text-glow {
          animation: textGlow 2s ease-in-out infinite;
        }
      `}</style>

      <div className="flex flex-col items-center justify-center min-h-[50vh] sm:min-h-[60vh]">
        {/* UNLOCK text */}
        <div className={`text-3xl sm:text-5xl font-black text-tessan-yellow mb-8 transition-all duration-500 ${showUnlock ? 'opacity-100 scale-100' : 'opacity-0 scale-50'}`}>
          BADGE DÉBLOQUÉ !
        </div>

        {/* Badge */}
        <div className="relative">
          {/* Cadenas qui disparaît */}
          {!showBadge && (
            <div className={`text-center ${showUnlock ? 'slide-up-fade' : 'opacity-0'}`}>
              <div className="w-32 h-32 sm:w-40 sm:h-40 bg-tessan-green-hover/50 rounded-2xl flex items-center justify-center border-4 border-tessan-cream/30">
                <span className="text-6xl">🔒</span>
              </div>
            </div>
          )}

          {/* Badge débloqué */}
          {showBadge && (
            <div className="slide-down-in">
              <div className="w-32 h-32 sm:w-44 sm:h-44 bg-tessan-cream rounded-2xl flex items-center justify-center shadow-2xl shadow-tessan-yellow/50 text-glow">
                <span className="text-6xl sm:text-8xl">{badge.emoji}</span>
              </div>
            </div>
          )}
        </div>

        {/* Infos du badge */}
        <div className={`mt-8 text-center transition-all duration-700 delay-500 ${showBadge ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          <div className="text-4xl font-bold text-tessan-yellow">{badge.name}</div>
          <div className="text-lg sm:text-xl text-tessan-cream mt-2">+{badge.points_awarded} points</div>
          <div className="text-tessan-cream/70 mt-4 max-w-[280px] sm:max-w-xs">{badge.description}</div>
        </div>
      </div>
    </AnimationLayout>
  )
}
